import { useContext, useEffect, useState } from "react";
import { Footer } from "../components/Footer";
import { Header } from "../components/Header";
import { AppContext } from "../App";
import { t } from "../i18n";

export const DamageType = () => {
	const { data } = useContext(AppContext);

	const [nextPage, setNextPage] = useState("damageArea");
	const previousPage = "damageGlass";

	useEffect(() => {
		setNextPage(
			data.damageType === "small" ? "damageArea" : "selectDateTime"
		);
	}, [data.damageType]);

	return (
		<>
			<Header />
			<Content />
			<Footer nextPage={nextPage} previousPage={previousPage} />
		</>
	);
};

const Content = () => {
	const { data, setData, isTransitioning } = useContext(AppContext);

	const updateDamageType = (damageType) => () => {
		setData({
			...data,
			damageType,
			damageArea: damageType === "large" ? "replacement" : null,
		});
	};

	return (
		<div
			className={
				"content kensei_03" + (isTransitioning ? " fade-in" : "")
			}
		>
			<div className="content_damage_type">
				<div className="content_title">
					<h2 className="select_damage_type">
						<strong>{t("Indica el tipo de daño")}</strong>
					</h2>
				</div>
				<div className="damage_type_options">
					<div
						className={
							"small_damage_type kensei_03" +
							(data.damageType === "small" ? " selected" : "")
						}
						onPointerDown={updateDamageType("small")}
					>
						<img
							src="resources/img/small_damage.png"
							alt="Menor que una moneda de 2€"
						/>
						<p>
							{t("<strong>Menor</strong> que una moneda de 2€")}
						</p>
					</div>
					<div
						className={
							"large_damage_type kensei_03" +
							(data.damageType === "large" ? " selected" : "")
						}
						onPointerDown={updateDamageType("large")}
					>
						<img
							src="resources/img/large_damage.png"
							alt="Mayor que una moneda de 2€"
						/>
						<p>
							{t("<strong>Mayor</strong> que una moneda de 2€")}
						</p>
					</div>
				</div>
			</div>
		</div>
	);
};
